package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJul162024StrAIberryChangingCameraFocusPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/jul162024StrAIberryChangingCameraFocus.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/jul162024-str-a-iberry-changing-camera-focus")
@Composable
fun Jul162024StrAIberryChangingCameraFocusPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("jul-16-2024-straiberry-changing-camera-focus") }) {
        org.jetbrains.compose.web.dom.Text("jul-16-2024-StrAIberry-Changing-Camera-Focus")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After changing the camera process from jaw detection to teeth detection, we faced an issue. This change has forced users to hold the camera much closer to their faces in order to detect molar teeth.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("1- This closeness caused the camera to lose focus, resulting in blurry frames.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("2- Another problem we faced was that the molar teeth were taking up the entire frame, making only the center molar clear (CameraX will centers the focus by default). Therefore, we needed to adjust the camera focus from the second molar to a point between the first and last molar.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("3- Focus changes must happen sequentially. Changing to the next focus point only upon completion of the current tooth detection and finishing current focus transaction (Camera focus changes has some delays).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To fix the first problem, we found a function in CameraX that returns an int value for ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("minimum_focus_distance")
        }
        org.jetbrains.compose.web.dom.Text(" on the current camera device. This value indicates the point at which the camera loses focus. Using this, we were able to warn both the code and the users when the camera was too close. Thanks to that, we were able to combine this value with the current frame’s teeth count and develop an algorithm to notify the user to move the phone either farther away or closer. For example, at the start of each checkup, we start on molar teeth. The frames related to this section must contain exactly three molar teeth from each side of the jaw.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The solution to the second issue was found not in CameraX, but in Camera2. CameraX did not have an API to control focus, whereas Camera2 offered a much deeper API, enabling us to change focus by defining specific focus points.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("// TODO code and explanation for third problem.")
    }
}
